/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_SpecialInputs */

const nl_validation_password_special = /** @type {(inputs: Validation_Password_SpecialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord moet minimaal één speciaal teken bevatten`)
};

/**

* @param {Validation_Password_SpecialInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_special = /** @type {((inputs?: Validation_Password_SpecialInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_SpecialInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_special(inputs)
});
export { validation_password_special as "validation.password.special" }